var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h2',[_vm._v("New "+_vm._s(_vm.schema.label))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('RecordForm',{attrs:{"schema":_vm.schema,"record":_vm.record,"persistRecord":_vm.persistRecord,"cancelForm":_vm.cancelForm}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be086f5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/record_new/components/layout.vue
// module id = ZrvJ
// module chunks = 1